import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a531859"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "flex justify-end ml-auto mb-3" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "search-container" }
const _hoisted_5 = { class: "flex w-full top" }
const _hoisted_6 = { class: "p-input-icon-left mb-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "w-full search-container" }
const _hoisted_10 = { class: "card-toolbar w-50 flex-none" }
const _hoisted_11 = { class: "flex flex-row align-items-center" }
const _hoisted_12 = { class: "card-actions ml-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "flex ml-auto w-full justify-end" }
const _hoisted_15 = { class: "card-body p-0" }
const _hoisted_16 = {
  key: 0,
  class: "badge border-white text-green-800 bg-green-200 p-4"
}
const _hoisted_17 = {
  key: 1,
  class: "badge border-white text-red-800 bg-red-200 p-4"
}
const _hoisted_18 = {
  key: 2,
  class: "badge border-white text-orange-800 bg-orange-200 p-4 ml-2"
}
const _hoisted_19 = {
  key: 3,
  class: "badge border-white text-purple-800 bg-purple-200 p-4 ml-2"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Actions", -1))

import {ref, onMounted, watch, onBeforeMount} from "vue";
import { useRouter } from "vue-router";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { productService } from "@/_services/product/product";
import { getPaginatedSupplierForDropDown } from "@/_services/supplier/supplier";
import { formatStatus } from "@/_helpers/stringManipulations";
import { IMasterProduct } from "@/models/product/IMasterProduct";
import swal from "@/_helpers/swal";
import {PRODUCT_PROTOTYPES} from "@/constants/product/properties";
import {SUPPLIER_UUIDS} from "@/_services/supplier/supplier";
import { IPatchProductStatusByBatchPlayload } from "@/models/product/IMasterProduct";
import DuplicateProductModal from "@/components/modal/product/DuplicateProductModal.vue";
import * as sweetalert2 from "sweetalert2";

const defaultRowsPerPage = 10;
const localStorageKey = "adminMasterProductBatchStatus";

const duplicateProductModalId = "duplicateProductModal";

export default /*#__PURE__*/_defineComponent({
  __name: 'ListProducts',
  setup(__props) {

const router = useRouter();


const isLoading = ref<boolean>(true);
const isSelectAllBtnChecked = ref<boolean>(false);
const masterProducts = Array<IMasterProduct>();
const tableData = ref<Array<IMasterProduct>>(masterProducts);
const rows = ref<number>(10);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const selectedStatusOptionForBatchUpdate = ref<boolean|null>(null);
const selectedOptionSupplier = ref<string|undefined>(undefined);
const selectedProducts = ref(Array<IMasterProduct>());
const productsOfCurrentPage = ref(Array<IMasterProduct>());
const totalSelectedProducts = ref<number>(0);
onBeforeMount(() => {
    initLocalStorageData();
});

onMounted(async () => {
  await populateDatatable();
});

const initLocalStorageData = () => {
    if (localStorage.getItem(localStorageKey)) {
        localStorage.removeItem(localStorageKey);
    }
}

const onFilterDt = () => {
    rows.value = 10;
    page.value = 1;
    currentPage.value = 0;
    populateDatatable();
};
const onClearInputFilter = () => {
    if (criteria.value === "") {
        rows.value = 10;
        page.value = 1;
        currentPage.value = 0;
        populateDatatable();
    }
};

watch(selectedOptionSupplier, () => {
    populateDatatable();
});

async function populateDatatable() {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await productService.fetchProduct(rows.value, page.value, criteria.value, selectedOptionSupplier.value);
    isLoading.value = loadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
    productsOfCurrentPage.value = tableData.value;
    
    return [isLoading.value, totalRecords.value, tableData.value]
}
const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await clearSelectedProducts();
    await populateDatatable();
};
const productUuid = ref<string>("");
const setUuidAndOpenModal = (uuid: string) => {
    productUuid.value = uuid;
    const duplicateProductFormModalElement:HTMLDialogElement | null = document.querySelector(`#${duplicateProductModalId}`);
    if (duplicateProductFormModalElement) {
        duplicateProductFormModalElement.showModal();
    }
};

const canDuplicate = (slotProps) => {
    const prototypeUuid = slotProps.data.prototype.uuid;
    const supplierUuid = slotProps.data.supplier.uuid;
    const allowedProductTypes = [PRODUCT_PROTOTYPES.TICKET, PRODUCT_PROTOTYPES.PHYSICAL];
    const restrictedSuppliers = [
        SUPPLIER_UUIDS.JACKPOT,
        SUPPLIER_UUIDS.PRESS,
        SUPPLIER_UUIDS.PROMO_PARC,
        SUPPLIER_UUIDS.CINE_CHEQUE,
        SUPPLIER_UUIDS.OGLOBA
    ];

    return allowedProductTypes.includes(prototypeUuid) && !restrictedSuppliers.includes(supplierUuid);
};

const onDelete = (data: IMasterProduct) => {
  swal
    .confirm("Êtes vous sur de vouloir archiver le produit ?")
    .then((result) => {
      if (result.isConfirmed) {
        productService.deleteMasterProduct(data.uuid).then(() => {
          swal.success("Archivé !", "Vous venez d'archiver le produit");
          refreshDatatable();
        });
      }
    });
};

const refreshDatatable = () => {
  populateDatatable();
};

async function searchSuppliers({ search, page, hasNextPage }) {
    const [totalSuppliersRecordsForDropDown, suppliersForDropDown] = await getPaginatedSupplierForDropDown(5, page, search, true);
    const hasItems = suppliersForDropDown.length > 0;
    if (hasItems && page !== totalSuppliersRecordsForDropDown) {
        hasNextPage();
    }
    
   return suppliersForDropDown;
}

const onSelectAllChange = async (event): Promise<void> => {
    showSpinner();
    if (true === event.checked) {
        isSelectAllBtnChecked.value = true;
        selectedProducts.value = productsOfCurrentPage.value;
        totalSelectedProducts.value = productsOfCurrentPage.value.length;
    } else {
        await clearSelectedProducts();
    }
    hideSpinner();
};

const clearSelectedProducts = async (): Promise<void> => {
    isSelectAllBtnChecked.value = false;
    selectedProducts.value = [];
    totalSelectedProducts.value = 0;
};

const onRowSelect = () => {
    if (totalSelectedProducts.value >= 0) {
        totalSelectedProducts.value++;
        if (totalSelectedProducts.value === productsOfCurrentPage.value.length) {
            isSelectAllBtnChecked.value = true;
        }
    }
}

const onRowUnselect = () => {
    if (totalSelectedProducts.value > 0) {
        totalSelectedProducts.value--;
        isSelectAllBtnChecked.value = false;
    }
}

const onSubmit = async (formData, formNode) => {
    try {
        const selectedProductsUuids = selectedProducts.value.map((product: IMasterProduct) => product.uuid);
        const payload: IPatchProductStatusByBatchPlayload = {
            isActive: formData.selected_status_for_batch_update,
            masterProductsUuids: selectedProductsUuids,
        }
        let action = payload.isActive ? 'activer' : 'désactiver';
        const warningMessage = `Êtes-vous sûr de vouloir ${action} les ${totalSelectedProducts.value} produits et variants associés ?`;
        swal.confirm(warningMessage, "Annuler")
            .then((result) =>  {
                if (result.isConfirmed) {
                    showSpinner();
                    productService.updateProductsStatusByBatch(payload).then(() => {
                        swal.success("", 'Les statuts ont bien été changés !').then(() => {
                            hideSpinner();
                            isSelectAllBtnChecked.value = false;
                            clearSelectedProducts();
                            populateDatatable();
                        });
                    });
                }
            });
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

const navigateToAddProduct = () => {
    router.push('/admin/addProduct');
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("catalogue.products.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        onClick: navigateToAddProduct,
        label: "Ajouter un produit",
        icon: "pi pi-plus",
        class: "button-add"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        globalFilterFields: ['properties.adminProductName.value'],
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        rowHover: true,
        selectAll: isSelectAllBtnChecked.value,
        lazy: "",
        paginator: "",
        onPage: onPaginate,
        selection: selectedProducts.value,
        "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((selectedProducts).value = $event)),
        onSelectAllChange: _cache[4] || (_cache[4] = ($event: any) => (onSelectAllChange($event))),
        onRowSelect: _cache[5] || (_cache[5] = ($event: any) => (onRowSelect())),
        onRowUnselect: _cache[6] || (_cache[6] = ($event: any) => (onRowUnselect())),
        stateStorage: "local",
        "state-key": localStorageKey
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(InputText), {
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                    onKeyup: _withKeys(onFilterDt, ["enter"]),
                    placeholder: "Rechercher un produit",
                    onInput: onClearInputFilter
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _hoisted_8,
                _createVNode(_component_FormKit, {
                  type: "autocomplete",
                  label: "",
                  name: "supplier",
                  placeholder: "Sélectionner un fournisseur",
                  options: searchSuppliers,
                  modelValue: selectedOptionSupplier.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOptionSupplier).value = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_FormKit, {
                type: "form",
                actions: false,
                onSubmit: onSubmit
              }, {
                default: _withCtx(({ state: { valid } }) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FormKit, {
                      type: "select",
                      name: "selected_status_for_batch_update",
                      modelValue: selectedStatusOptionForBatchUpdate.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedStatusOptionForBatchUpdate).value = $event)),
                      options: [
                                { label: 'Changer de statut', value: null },
                                { label: 'Activé', value: true },
                                { label: 'Désactivé', value: false },
                            ]
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_12, [
                      (!isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: "Appliquer",
                              disabled: !valid || totalSelectedProducts.value <= 0 || selectedStatusOptionForBatchUpdate.value === null
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, "Nombre de ligne sélectionnée(s) : " + _toDisplayString(totalSelectedProducts.value) + " produit(s)", 1)
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(Column), { selectionMode: "multiple" }),
            _createVNode(_unref(Column), {
              field: "properties.adminProductName.value",
              header: "Nom du produit",
              filterField: "properties.adminProductName.value"
            }),
            _createVNode(_unref(Column), {
              field: "prototype.value",
              header: "Type de produit"
            }),
            _createVNode(_unref(Column), {
              field: "specialProperties.brand.value",
              header: "Marque"
            }),
            _createVNode(_unref(Column), {
              field: "supplier.value",
              header: "Fournisseur"
            }),
            _createVNode(_unref(Column), {
              field: "status",
              header: "Statut"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.status?.active)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Activé "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, " Désactivé ")),
                (slotProps.data.status?.hiddenProduct)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Masqué "))
                  : _createCommentVNode("", true),
                (slotProps.data.status?.closedSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Vente fermée "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              headerStyle: "width: 14em;",
              class: "whitespace-nowrap"
            }, {
              header: _withCtx(() => [
                _hoisted_20
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  to: { name: 'EditProduct', params: { uuid: slotProps.data.uuid }}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      size: "small",
                      icon: "pi pi-pencil",
                      class: _normalizeClass(["p-edition", `${slotProps.data.uuid}`]),
                      style: {"margin-right":"0.5em"},
                      title: "Éditer"
                    }, null, 8, ["class"])
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-trash",
                  class: "p-button-danger",
                  style: {"margin-right":"0.5em"},
                  title: "Supprimer",
                  onClick: ($event: any) => (onDelete(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_router_link, {
                  to: { name: 'listProductVariants', params: { uuid: slotProps.data.uuid }}
                }, {
                  default: _withCtx(() => [
                    (slotProps.data.prototype.uuid !== _unref(PRODUCT_PROTOTYPES).PROMO &&
            slotProps.data.prototype.uuid !== _unref(PRODUCT_PROTOTYPES).MEMBER)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          size: "small",
                          icon: "pi pi-eye",
                          class: _normalizeClass(["p-button-info p-button-eye", `${slotProps.data.uuid}`]),
                          style: {"margin-right":"0.5em"},
                          title: "Voir les variants"
                        }, null, 8, ["class"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (canDuplicate(slotProps))
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      size: "small",
                      icon: "pi pi-clone",
                      class: "p-button-warning",
                      style: {"margin-right":"0.5em"},
                      title: "Dupliquer",
                      onClick: ($event: any) => (setUuidAndOpenModal(slotProps.data.uuid))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "globalFilterFields", "totalRecords", "currentPage", "selectAll", "selection"]),
      _createVNode(DuplicateProductModal, {
        "product-uuid": productUuid.value,
        "duplicate-product-modal-id": duplicateProductModalId
      }, null, 8, ["product-uuid"])
    ])
  ], 64))
}
}

})